import { createContext } from "react";

const ChatContext = createContext({
  open: false,
  handle: () => {},
  minimize: false,
  minimizeHandle: () => {},
});

export default ChatContext;